const Resource = {
    lang: 'en-us',
    currencySymbol: '$',
    text: {
      messages: {
        tryAgain: 'Try again soon',
      },
      validations: {
        invalidUserPwdText: 'Invalid user name or password',
        requiredText: 'Required',
      },
      values: {
        selectOneValueText: '--SELECT--',
      },
      buttons: {
        loginButtonText: 'Login',
        logoutButtonText: 'Logout',
        cancelButtonText: 'Cancel',
        endLaneButtonText: 'End Lane',
        pauseLaneButtonText: 'Pause Lane',
        continueLaneButtonText: 'Continue Lane',
        restartLaneButtonText: 'Restart Lane',
        resumeButtonText: 'Resume',
        reRunButtonText: 'Re-Run',
        bidButtonText: 'Bid',
        retractBidButtonText: 'Retract Bid',
        floorBidderOverrideButtonText: 'Floor Bidder Override',
        soldButtonText: 'Sold',
        confirmSoldButtonText: 'Confirm Sold',
        ifSaleButtonText: 'If Sale',
        confirmIfSaleButtonText: 'Confirm If Sale',
        noSaleButtonText: 'No Sale',
        confirmNoSaleButtonText: 'Confirm No Sale',
        sendButtonText: 'Send',
        pinMessageButtonText: 'Pin Message',
        muteMicrophoneButtonText: 'Mute Microphone',
        unmuteMicrophoneButtonText: 'Unmute Microphone',
      },
      labels: {
        loginHeaderText: 'Simulcast Login',
        userNameLabelText: 'Username',
        passwordLabelText: 'Password',
        auctionLabelText: 'Choose Auction',
        laneLabelText: 'Choose Lane',
        selectScreenHeaderText: 'Select a Screen',
        connectedLabelText: 'Connected',
        disconnectedLabelText: 'Disconnected',
        networkErrorLabelText: 'Network Error',
        itemLabelText: 'Item',
        openItemLabelText: 'Open Item #',
        okayToSellLabelText: 'Okay to Sell',
        sidePanel: {
          preferences: {
            preferencesLabelText: 'Preferences',
          },
          settings: {
            settingsLabelText: 'Settings',
          },
          bidActivity: {
            bidActivityLabelText: 'Bid Activity',
            searchInputPlaceholderText: 'Search activity by name',
          },
          onlineBidders: {
            onlineBiddersLabelText: 'Online Bidders',
            searchInputPlaceholderText: 'Search...',
            descriptionText: 'This is a user list description...',
          },
          runList: {
            runListLabelText: 'Run List',
            searchInputPlaceholderText: 'Search items by name, lot number',
            descriptionText:
              'You may click one of the items from the list below to load into the auction window.',
            filterMappingText: [
              { label: 'Not Statused', translation: 'Not Statused' },
              { label: 'Open', translation: 'Open' },
              { label: 'Subject To', translation: 'SubjectTo' },
              { label: 'Sold', translation: 'Sold' },
              { label: 'No Sale', translation: 'No Sale' },
            ],
          },
          help: {
            helpLabelText: 'Help',
            descriptionText: '',
          },
        },
        chat: {
          headerLabelText: 'LIVE CHAT',
          filterTypeLabelText: 'Filter Type',
          filterTypeSelectOneText: '- Choose -',
          filterTypeMappingValueText: [
            { label: 'Bidder Name', translation: 'Bidder Name' },
            { label: 'Bidder Badge', translation: 'Bidder Badge' },
            { label: 'Item #', translation: 'Item #' },
            { label: 'Global Messages', translation: 'Global Messages' },
            { label: 'Content', translation: 'Content' },
          ],
          filterTextLabelText: 'Filter Text',
          filterTextPlaceholderText: 'Enter filter text',
          userTabLabelText: 'User',
          userTabPlaceholderText: 'Select a user...',
          globalTabLabelText: 'Global',
          globalTabMessageText: 'Send message to all enabled users',
          globalTabPlaceholderText: 'Type message...',
          pinnedTabLabelText: 'Pinned',
          pinnedMessageText: 'Pin a message to the bid client',
          pinnedTabPlaceholderText: 'Type message...',
          pinnedTabChooseTemplateLinkText: 'Choose from template',
        },
        attributes: {
          targetLabelText: 'Target',
          crLabelText: 'CR',
          milesHoursLabelText: 'MI/HR',
          docsLabelText: 'Docs',
          sellerLabelText: 'Seller',
          reserveLabelText: 'Reserve',
          bookValueLabelText: 'Book Value',
          proxyBidsLabelText: 'Proxy Bids',
          noBidsLabelText: 'No bids',
          noCommentsLabelText: 'No comments',
        },
      },
      confirmationWindow: {
        floorBidderBadge: {
          messageText: '',
          cancelButtonText: "No, I'll fix it",
          proceedButton: 'Proceed',
        },
        endLane: {
          endLaneConfirmationTitleText:
            'Are you sure you would like to end the lane?',
          endLaneConfirmationMessageText:
            'Ending the {LANE_NAME} lane will send the following message to all online bidders on this lane:',
          endLaneButtonText: 'End Lane',
        },
        logout: {
          logoutConfirmationTitleText: 'Are you sure you want to logout?',
          logoutMessage:
            "Your connection will be terminated. Even though the {LANE_NAME} lane is running, online bidders will not be impacted; however, if you wish to end the lane, then you must cancel, then click the 'End Lane' button on the main screen.",
          logoutButtonText: 'Logout',
        },
      },
  
      screen: {
        login: {
          headerText: 'Simulcast Portal Login',
          loginButtonText: 'Login',
          helpLabelText: 'Help',
          userNameLabel: 'Username',
          passwordLabel: 'Password',
          auctionLabelText: 'Choose Auction',
          laneLabelText: 'Choose Lane',
          providerSelectText: '---Select a Provider---',
          selectScreenHeaderText: 'Select a Screen',
          switchAuctionButtonText: 'SWITCH AUCTION/LANE',
          logoutButtonText: 'SIGNOUT',
        },
        clerk: {
          connectedLabel: {
            connected: 'Connected',
            disconnected: 'Disconnected',
            networkError: 'Network Error',
          },
        },
      },
    },
  };
  
  export default Resource;
  